import * as React from 'react';
import styled from 'styled-components';
import { space, color, themeGet } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { Image } from 'react-feather';
import { FillLoader, UploaderCrop as Uploader, Modal } from '.';
import { Mutation } from 'react-apollo';
import { SteynCityContext } from './ContextProvider';
import { ImageTypes, ImageObject } from '../utils/types';
import ImageOverlay, { Overlay } from './ImageOverlay';
import {
  // UpdateVendorDocument,
  UpdateEventDocument,
  UpdatePostDocument,
  UpdateUserDocument,
  UpdateStakeholderDocument,
  UpdatePropertyDocument,
  // UpdateGuestDocument,
  // UpdateClubDocument,
} from '../generated/graphql';

const ImageContainer = styled.img`
  height: ${(props) => props.height || 'auto'};
  display: block;
  max-width: 100%;
  position: relative;
  border-radius: 4px;
`;

const Wrapper = styled.div<StyledSystemProps>`
  ${space};
  display: flex;
  overflow: hidden;
  flex-flow: column;
  position: relative;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid ${themeGet('colors.paleGrey', '#EEE')};
  &:hover ${Overlay} {
    bottom: 0;
    opacity: 1;
    pointer-events: all;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

const Placeholder = styled.div<StyledSystemProps>`
  ${color};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '300px'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  src?: string | null;
  color?: string;
  id?: string;
  type?: ImageTypes;
  editable?: boolean;
  uploadText?: string;
  hostLogo?: boolean;
  width?: string | number;
  height?: string | number;
  className?: string;
  onUpload: (image: ImageObject) => void;
  initialImage?: ImageObject;
}

const HeroImageCrop: React.FC<Props> = (props) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const context = React.useContext(SteynCityContext);

  const handleUploadSuccess = (response: any) => {
    // Transform the Uppy response into ImageObject format
    const imageObject: ImageObject = {
      original: response.original,
      thumbnail: response.thumbnail,
      scaled: response.scaled
    };
    props.onUpload(imageObject);
    setModalVisible(false);
  };

  const { src, type, editable, width, height, uploadText, className } = props;
  return (
    <Mutation
      mutation={
        type === 'profile'
          ? UpdateUserDocument
          : type === 'property'
          ? UpdatePropertyDocument
          : type === 'post'
          ? UpdatePostDocument
          : type === 'stakeholder'
          ? UpdateStakeholderDocument
          : type === 'event'
          ? UpdateEventDocument
          : UpdatePropertyDocument
      }
      onCompleted={() => context.addToast('Image updated successfully!', 'SUCCESS')}
    >
      {(mutation, { loading, error }) => {
        if (error) {
          context.addToast('Sorry, something went wrong.', 'ERROR');
        }
        return (
          <React.Fragment>
            <Modal open={modalVisible} onClose={() => setModalVisible(false)} heading="Upload Image">
              <Uploader
                onComplete={handleUploadSuccess}
                handleUploadSuccess={handleUploadSuccess}
                initialImage={props.initialImage}
                allowedFileTypes={['image/*']}
              />
            </Modal>
            <Wrapper mb={4} className={className}>
              {src ? (
                <React.Fragment>
                  <ImageContainer src={src} width={width} />
                  {editable && <ImageOverlay uploadText={uploadText || 'EDIT'} onClick={() => setModalVisible(true)} />}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Placeholder bg="transparentBlack" width={width} height={height}>
                    <Image size={80} color="white" />
                  </Placeholder>
                  {editable && (
                    <ImageOverlay uploadText={uploadText || 'ADD PHOTO'} onClick={() => setModalVisible(true)} />
                  )}
                </React.Fragment>
              )}
              {loading && <FillLoader hasBackground={true} />}
            </Wrapper>
          </React.Fragment>
        );
      }}
    </Mutation>
  );
};

export default HeroImageCrop;

HeroImageCrop.defaultProps = {
  editable: true,
};



// WEBPACK FOOTER //
// ./src/components/HeroImageCrop.tsx